<ion-content class="ion-no-padding">
  <form class="lead-form model-container" [formGroup]="clientForm">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">Edit Client Details</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          
          <!-- <ion-button  class="filled-blue-btn">
            Save & New
          </ion-button> -->
          <ion-button class="filled-blue-btn" (click)="onSubmit()">
            Save
          </ion-button>
          <ion-button (click)="closeModal()" class="unfilled-gray-btn">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line mb-1"></div>

      <!-- lead-details form -->
      <div class="ion-padding-horizontal d-flex justify-content-between">
        <ion-title class="dark-title-sm ion-no-padding">Client Details</ion-title>
        
      </div>
      <div class="form-container ion-padding-horizontal toggle-visibility">
        
        <div class="row">

          <div class="col-6">
            <div class="input-container">
              <label for="phone" class="label">Phone Number*</label>
              <div [ngClass]="{ 'invalid-input': clientForm.get('phoneNumber')?.invalid && clientForm.get('phoneNumber')?.touched }">
                <app-phone-country-input formControlName="phoneNumber"></app-phone-country-input>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="email" class="label">Email ID</label>
              <div [ngClass]="{ 'invalid-input': clientForm.get('emailId')?.invalid && clientForm.get('emailId')?.touched }">
                <input class="input-text input" type="text" id="email" placeholder="Ex: someone@mail.com" formControlName="emailId">
              </div>
            </div>          
          </div>
        </div>
        
        <div class="row">
          <div class="col-6">
            <div class="input-container">
              <label for="first-name" class="label">First Name*</label>
              <div [ngClass]="{ 'invalid-input': clientForm.get('firstNameWithSalutation')?.invalid && clientForm.get('firstNameWithSalutation')?.touched }">
                <!-- <input class="input-text input" type="text" id="first-name" placeholder="Enter Leads First Name" formControlName="firstName"> -->
                <app-first-name-salutation formControlName="firstNameWithSalutation"></app-first-name-salutation>
              </div>
              
            </div>
          </div>
          <div class="col-6">
            <div class="input-container">
              <label for="last-name" class="label">Last Name</label>
              <div [ngClass]="{ 'invalid-input': clientForm.get('lastName')?.invalid && clientForm.get('lastName')?.touched }">
                <input class="input-text input" type="text" id="last-name" placeholder="Enter Leads Last Name" formControlName="lastName" appRestrictSpecialChars appRestrictNumbers>
              </div>
            </div>          
          </div>
        </div>
      </div>
      <div class="dashed-line mt-3"></div>

    </div>


    <!-- Save button -->
    <!-- <div *ngIf="!editLeadId" class="model-footer ion-padding-horizontal bg-light-gray">
      <ion-button class="filled-blue-btn" type="submit" (click)="onSubmit(undefined, true)">Next</ion-button>
    </div> -->
  </form>
</ion-content>